export default "__VITE_ASSET__DPv410wQ__"